import styled from "styled-components";

export const ListContainer = styled.div`
  background: white;
  padding: 0 24px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.1);
`;
